export default class WhiteboardError extends Error {}
